import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { omittedBrandsSelector, quoteFormSelector, resultsConfigSelector, sortedAndFilteredProductsSelector } from 'ctm-selectors';
import { SimpleFlexbox, ModalButton } from 'ctm-components';
import { getHasSavedResults } from 'ctm-selectors/selectors/results';
import { homeOrProperty } from '../../../core/state_selectors';
import SavedResultsMessage from './components/saved_results_message';
import { UpdateQuoteModal } from './components/update_quote_dialog';
import AvailableResultsMessage from './components/available_results_message';
import { handleQuoteModal } from './handle_quote_modal';

/**
 * WelcomeMessage displays Results welcome message with Icon child and available results count
 * This component also conditionally renders the Saved Results element if prefill is enabled and there are saved results
 * @param {Object} props - component's props
 * @returns {Node} WelcomeMessage The welcome message component
 */
const _WelcomeMessage = (props) => {
    const { results, showFeaturesDisclaimer, suburb = '', propertyType = '', dispatch, hasActiveFilter, previousHomeExcess, previousContentsExcess } = props;

    const resultsLength = results && results.length;
    const hasSavedResults =  getHasSavedResults();
    if (results === null || typeof results === 'undefined' || (resultsLength === 0)) {
        return null;
    }

    const renderUpdateQuotesModal = () => {
        const contentProps = {
            label: 'Update Quotes'
        };

        const elementProps = {
            'data-id': 'savedResults.ModalDialog.updateQuotes',
            href: 'javascript:;',
            tagName: 'a',
            id: 'savedResults.ModalDialog.updateQuotes'
        };
        return (
            <ModalButton contentProps={contentProps}
                elementProps={elementProps}
                onClickFunction={() => {
                    handleQuoteModal(dispatch, true);
                }} />
        );
    };

    return (
        <SimpleFlexbox
            column="xs"
            row="sm"
            contentBetween="xs"
            itemsCenter="xs"
            display="flex"
            md={9}
            lg={9}
            xl={10}
            xxl={12}
            margin={['top', 'bottom_xsmall']}
        >
            <SimpleFlexbox display="block" contentBetween="xs" itemsCenter="xs">
                <AvailableResultsMessage
                    resultsLength={resultsLength}
                    hasSavedResults={hasSavedResults}
                    suburb={suburb}
                    propertyType={propertyType}
                    showFeaturesDisclaimer={showFeaturesDisclaimer} />
                {hasSavedResults ? <SavedResultsMessage renderUpdatesQuoteModal={renderUpdateQuotesModal} /> : <></>}
                <UpdateQuoteModal closeModal={() => handleQuoteModal(dispatch, false, previousHomeExcess, previousContentsExcess, hasActiveFilter)} />
            </SimpleFlexbox>
        </SimpleFlexbox>
    );
};

_WelcomeMessage.propTypes = {
    results: PropTypes.array,
    suburb: PropTypes.string,
    propertyType: PropTypes.string,
    showFeaturesDisclaimer: PropTypes.bool
};

const mapStateToProps = (state) => {
    const resultsConfig = resultsConfigSelector(state);
    const omittedBrands = omittedBrandsSelector(state) || [];
    const form = quoteFormSelector(state);
    // Get the sorted quotes based on store config
    const quotes = sortedAndFilteredProductsSelector(state).filter((quote) => {
        const providerCode = quote.getIn(['providerMeta', 'code']);
        return !omittedBrands.some((omittedProviderMeta) =>  omittedProviderMeta.get('code') === providerCode);
    });
    const displayMode = resultsConfig.get('displayMode');
    const showFeaturesDisclaimer = (
        displayMode === 'column'
    );
    const homeExcessFilterValue = form.getIn(['excessDetails', 'homeExcess']).toString();
    const contentsExcessFilterValue = form.getIn(['excessDetails', 'contentsExcess']).toString();

    let hasActiveFilter = form.getIn(['helpers', 'prefill', 'isResultsFilterActive']);
    hasActiveFilter = !!hasActiveFilter ? hasActiveFilter : false;

    const previousHomeExcess = form.getIn(['helpers', 'prefill', 'previousHomeExcess']);
    const previousContentsExcess = form.getIn(['helpers', 'prefill', 'previousContentsExcess']);
    return {
        results: quotes.toJS() || [],
        suburb: quoteFormSelector(state).getIn(['property', 'address', 'suburb']),
        propertyType: homeOrProperty({ state }),
        showFeaturesDisclaimer,
        homeExcessFilterValue,
        contentsExcessFilterValue,
        hasActiveFilter,
        resultsConfig,
        previousHomeExcess,
        previousContentsExcess
    };
};

const WelcomeMessage = connect(mapStateToProps)(_WelcomeMessage);

export { _WelcomeMessage, WelcomeMessage };
